// extracted by mini-css-extract-plugin
module.exports = {"action":"ChecklistField_action__2Pw1-","view":"ChecklistField_view__2ANBc","footerAction":"ChecklistField_footerAction__1d_nb"};